export default __webpack_public_path__ + "static/media/c_2.13a5884c.jpeg";